/**
 * Unit of measurement functions.
 */
import { curry } from "ramda"

const isNumber = (n: any) =>
  !isNaN(parseFloat(n)) && !isNaN(n - 0) && !(n === 0 || n === "0")
const toUnit = (unit: string) => (n: string | number) =>
  isNumber(n) ? n + unit : (n as string)

export const px = toUnit("px")
export const percent = toUnit("%")
export const pixelsToRem = curry(
  (baseFontSize: number, px: number) => px / baseFontSize + "rem"
)
